import { SET_REPLY_TIMELINE_ID } from 'reduxes/slices/timelines/actions'

import { removeKeyFromState } from '../../util/reducers'

export function replyTimelineId(state = {}, action) {
  switch (action.type) {
    case SET_REPLY_TIMELINE_ID:
      if (action.id) {
        return {
          ...state,
          [action.topicId]: action.id,
        }
      } else {
        return removeKeyFromState(state, action.topicId)
      }
    default:
      return state
  }
}
